import { Box } from "@mui/system";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MachineListComponent, {
  MachineBox,
  MachineBoxUseCopy,
} from "./MachineListComponent/MachineListComponent";
import { useTranslation } from "react-i18next";
import {
  getAllMachinesList,
  postMachinesList,
} from "../../services/machineService";
import { ApplicationId } from "../../api/url";
import { json, useLocation, useNavigate, useParams } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import CopyIcon from "../../assets/img/images/copy.png";
import { Path } from "../../Utils/ScreenPath";
import { Grid, Menu, Pagination } from "@mui/material";
import GridIcon from "../../assets/img/svg/Grid_Icon.svg";
import FilterIcon from "../../assets/img/svg/equalizer-line.svg";

const getInitialFilter = () => {
  try {
    const storedData = localStorage.getItem("selectFilter");
    return storedData ? JSON.parse(storedData) || defaultFilter : defaultFilter;
  } catch (error) {
    console.error("Error parsing machine-list from localStorage:", error);
    return defaultFilter;
  }
};
const defaultFilter = {
  "45,000-80,000lbs": false,
  "80,001-95,000lbs": false,
  "95,001-125,000lbs": false,
};

const EquipmentComponent = ({ AttachmentsListPage }) => {
  const { state } = useLocation();
  const { id } = useParams();

  const [selectFilter, setSelectFilter] = useState(getInitialFilter());

  const [assetStartingLoader, setAssetStartingLoader] = useState(true);
  const [
    assetCategorizationSummaryLoading,
    setAssetCategorizationSummaryLoading,
  ] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectCategoryType, setSelectCategoryType] = useState();
  const [AssetTypeList, setAssetTypeList] = useState([]);
  // -----------
  const [assetTypeId, setAssetTypeId] = useState("");
  const [machineTypeSelectIdCategoryName, setMachineTypeSelectIdCategoryName] =
    useState("");
  const [allFilterID, setAllFilterID] = useState(null);
  const [pageNumber, setPageNumber] = useState(
    localStorage.getItem("currentPage") || 1
  );
  const [isMachineData, setIsMachineData] = useState([]);
  const [dataLoadLoading, setDataLoadLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [machinesTypeList, setMachinesTypeList] = useState([]);
  const [categoryofMachineList, setCategoryofMachineList] = useState();
  const [selecedEquipment, setSelecedEquipment] = useState([]);
  const [selectedCheckList, setSelectedCheckList] = useState(false);
  const [copyMachine, setCopyMachine] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const machineRefs = useRef([]);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const limit = 9;
  const navigate = useNavigate();

  const [assetList, setAssetList] = useState({
    ShowTitle: "",
    selectAssetDetails: {},
    CategoryDetails: {},
    Tier1Details: [],
    Tier1Select: {},
    Tier2Details: [],
    Tier2Select: {},
    Tier3Details: [],
    Tier3Select: {},
    Tier4Details: [],
    Tier4Select: {},
    Tier5Details: [],
    Tier5Select: {},
    tierCount: 0,
    TierData: false,
    ShowBackBTN: false,
    ShowTitle: "",
  });
  const { t } = useTranslation();

  const GetMachinesList = () => {
    setIsLoading(false);
  };

  // const weightMapping = {
  //   "75,000-95,000lbs": { MinMachineWeight: 45000, MaxMachineWeight: 70000 },
  //   "95,001-125,000lbs": { MinMachineWeight: 90001, MaxMachineWeight: 125000 },
  // };

  const weightMapping = {
    "45,000-80,000lbs": { Tier1Name: "45,000 - 80,000 lbs" },
    "80,001-95,000lbs": { Tier1Name: "80,001 - 95,000 lbs" },
    "95,001-125,000lbs": { Tier1Name: "95,001 - 125,000 lbs" },
  };

  const getWeightFilter = () => {
    const selectedWeights = Object.keys(selectFilter).filter(
      (key) => selectFilter?.[key]
    );

    if (selectedWeights?.length > 0) {
      return {
        Tier1Names: selectedWeights
          .map((key) => weightMapping?.[key]?.Tier1Name)
          .filter(Boolean), // removes null, undefined, false
      };
    }

    return { Tier1Names: [] };
  };

  const handelSelectFilter = () => {
    setPageNumber(1);
    localStorage.setItem("currentPage", Number(1));
    setIsLoading(true);
    setRefresh(!refresh);
  };

  useEffect(() => {
    GetMachinesList();
    if (window.location.href.split("userID=")?.[1]) {
      localStorage.setItem(
        "UserID",
        window.location.href.split("userID=")?.[1]
      );
    }
  }, []);

  useEffect(() => {
    GetMachinesTypeList();
  }, []);

  useEffect(() => {
    if (isMachineData?.length > 0) {
      if (localStorage.getItem("selectMachineID")) {
        const machineIndex = isMachineData.findIndex(
          (machine) => machine.id == localStorage.getItem("selectMachineID")
        );
        if (machineIndex !== -1 && machineRefs.current[machineIndex]) {
          machineRefs.current[machineIndex].scrollIntoView({
            behavior: "smooth",
            block: "center", // Adjust based on where you want to scroll the machine (top, center, etc.)
          });
        }
      }

      localStorage.removeItem("selectMachineID");
    }
  }, [isMachineData, localStorage.getItem("selectMachineID")]);

  const GetMachinesTypeList = (val) => {
    setAssetCategorizationSummaryLoading(true);
    getAllMachinesList()
      .then((res) => {
        const WithoutAttachmentsList = res?.data;

        setAssetTypeList(WithoutAttachmentsList);
        setAssetCategorizationSummaryLoading(false);
      })
      .catch((err) => console.log(err));
  };

  // ----------------
  const GetMachinesListSidebar = (val) => {
    // if (isMachineData?.length === 0) {
    setIsLoading(true);
    // }
    setDataLoadLoading(true);
    setCategoryofMachineList(undefined);
    let payload;

    if (allFilterID) {
      payload = {
        AssetTypeId:
          assetTypeId && assetTypeId !== undefined
            ? JSON.parse(assetTypeId)
            : null,
        PageSize: limit,
        PageNumber: pageNumber,
        // IsMachineListPage: true,
        Tier1Id: JSON.parse(allFilterID[2]),
        Tier2Id: JSON.parse(allFilterID[3]),
        Tier3Id: JSON.parse(allFilterID[4]),
        CategoryId: JSON.parse(allFilterID[5]),
      };
    } else if (val) {
      // ------------------ Split zero CategoryName ------------------
      // ------------------ Split One AssetTypeId --------------------
      // ------------------ Split two Tier1Id --------------------
      // ------------------ Split three Tier2Id --------------------
      // ------------------ Split four Tier3Id ------------------
      // ------------------ Split five CategoryId ------------------
      const IDs = val?.split(",");
      payload = {
        AssetTypeId: JSON.parse(IDs?.[1]) ?? null,
        PageSize: limit,
        PageNumber: pageNumber,
        // IsMachineListPage: true,
        Tier1Id: JSON.parse(IDs?.[2]) ?? null,
        Tier2Id: JSON.parse(IDs?.[3]) ?? null,
        Tier3Id: JSON.parse(IDs?.[4]) ?? null,
        CategoryId: JSON.parse(IDs?.[5]) ?? null,
      };
    } else {
      payload = {
        AssetTypeId: assetTypeId,
        PageSize: limit,
        PageNumber: pageNumber,
        // IsMachineListPage: true,
      };
    }
    payload = {
      ...payload,
      IsOldiesByGoodies: false,
      SortColumn: "SortOrder ASC",
    };

    payload = {
      ...payload,
      ...getWeightFilter(),
      ApplicationId: ApplicationId,
    };
    postMachinesList(payload)
      .then((res) => {
        const machineData = res && res.data;
        setTotalRecords(machineData?.TotalRecords);
        if (parseInt(machineData?.PageNumber) == 1) {
          setIsMachineData(machineData?.machines);
        } else {
          setIsMachineData(machineData?.machines);
        }
        setIsLoading(false);
        setAssetStartingLoader(false);
        setDataLoadLoading(false);
      })
      .catch((err) => {
        setAssetStartingLoader(false);
      });
  };

  const handleOnChangeTypePreviousPageDetails = (e) => {
    // ------------------ Split zero CategoryName ------------------
    // ------------------ Split One AssetTypeId --------------------
    // ------------------ Split two Tier1Id --------------------
    // ------------------ Split three Tier2Id --------------------
    // ------------------ Split four Tier3Id ------------------
    // ------------------ Split five CategoryId ------------------
    const IDs = e.split(",");
    setAllFilterID(IDs);
    setMachineTypeSelectIdCategoryName(IDs[0]);
    setAssetTypeId(IDs[1]);
    GetMachinesListSidebar(e);
  };

  const handleOnChangeType = (e) => {
    // ------------------ Split zero CategoryName ------------------
    // ------------------ Split One AssetTypeId --------------------
    // ------------------ Split two Tier1Id --------------------
    // ------------------ Split three Tier2Id --------------------
    // ------------------ Split four Tier3Id ------------------
    // ------------------ Split five CategoryId ------------------
    setIsMachineData([]);
    if (e !== "") {
      const IDs = e.split(",");
      setAllFilterID(IDs);
      setMachineTypeSelectIdCategoryName(IDs[0]);
      if (IDs[1] !== undefined) {
        setAssetTypeId(IDs[1]);
      }
    } else {
      setAllFilterID(null);
      setMachineTypeSelectIdCategoryName("");
      setAssetTypeId("");
    }
  };

  const handelSelectAssetTypeList = async (item, Type) => {
    setSelectCategoryType(item);
    // resetPagination();
    if (Type?.Type === "AssetList") {
      setAssetList({
        ...assetList,
        ShowTitle: item?.AssetTypeName,
        selectAssetDetails: item,
        ShowBackBTN: true,
      });
      handleOnChangeType(
        `${null},${item?.AssetTypeId},${null},${null},${null},${null}`
      );
    } else if (Type?.Type === "CategoryDetails") {
      handleOnChangeType(
        `${item?.CategoryName},${2},${null},${null},${null},${item?.CategoryId}`
      );
      return setAssetList({
        ...assetList,
        CategoryDetails: item,
        ShowTitle: item?.CategoryName,
        Tier1Details: item?.Tier1Details,
        tierCount: assetList?.tierCount + 1,
        TierData: true,
      });
    } else if (Type?.Type === "TierData") {
      if (
        item?.[`Tier${assetList?.tierCount + 1}Details`] !== undefined &&
        item?.[`Tier${assetList?.tierCount + 1}Details`]?.length !== 0
      ) {
        switch (assetList?.tierCount) {
          case 0:
            handleOnChangeType(
              `${assetList?.CategoryDetails?.CategoryName},${
                assetList?.selectAssetDetails?.AssetTypeId
              },${null},${null},${null},${
                assetList?.CategoryDetails?.CategoryId
              }`
            );
            return setAssetList({
              ...assetList,
              Tier1Details: item?.Tier1Details,
              tierCount: assetList?.tierCount + 1,
              TierData: true,
            });
          case 1:
            handleOnChangeType(
              `${assetList?.CategoryDetails?.CategoryName},${
                assetList?.selectAssetDetails?.AssetTypeId
              },${item?.Tier1Id},${null},${null},${
                assetList?.CategoryDetails?.CategoryId
              }`
            );
            return setAssetList({
              ...assetList,
              ShowTitle: item?.Tier1Name,
              Tier1Select: item,
              Tier2Details: item?.Tier2Details,
              tierCount: assetList?.tierCount + 1,
              TierData: true,
            });
          case 2:
            handleOnChangeType(
              `${assetList?.CategoryDetails?.CategoryName},${
                assetList?.selectAssetDetails?.AssetTypeId
              },${assetList?.Tier1Select?.Tier1Id},${item?.Tier2Id},${null},${
                assetList?.CategoryDetails?.CategoryId
              }`
            );
            return setAssetList({
              ...assetList,
              ShowTitle: item?.Tier2Name,
              Tier2Select: item,
              Tier3Details: item?.Tier3Details,
              tierCount: assetList?.tierCount + 1,
              TierData: true,
            });
          case 3:
            handleOnChangeType(
              `${assetList?.CategoryDetails?.CategoryName},${assetList?.selectAssetDetails?.AssetTypeId},${assetList?.Tier1Select?.Tier1Id},${assetList?.Tier2Select?.Tier2Id},${item?.Tier3Id},${assetList?.CategoryDetails?.CategoryId}`
            );
            return setAssetList({
              ...assetList,
              ShowTitle: item?.Tier3Name,
              Tier3Select: item,
              Tier4Details: item?.Tier4Details,
              tierCount: assetList?.tierCount + 1,
              TierData: true,
            });
          case 4:
            return setAssetList({
              ...assetList,
              ShowTitle: item?.Tier4Name,
              Tier4Select: item,
              Tier5Details: item?.Tier5Details,
              tierCount: assetList?.tierCount + 1,
              TierData: true,
            });
          default:
            return;
        }
      } else {
        switch (assetList?.tierCount) {
          case 0:
            return setAssetList({
              ...assetList,
              Tier1Details: item?.Tier1Details,
              TierData: true,
            });
          case 1:
            return setAssetList({
              ...assetList,
              ShowTitle: item?.Tier1Name,
              Tier1Select: item,
              Tier2Details: item?.Tier2Details,
              TierData: true,
            });
          case 2:
            return setAssetList({
              ...assetList,
              ShowTitle: item?.Tier2Name,
              Tier2Select: item,
              Tier3Details: item?.Tier3Details,
              TierData: true,
            });
          case 3:
            handleOnChangeType(
              `${assetList?.CategoryDetails?.CategoryName},${assetList?.selectAssetDetails?.AssetTypeId},${assetList?.Tier1Select?.Tier1Id},${assetList?.Tier2Select?.Tier2Id},${item?.Tier3Id},${assetList?.CategoryDetails?.CategoryId}`
            );
            return setAssetList({
              ...assetList,
              ShowTitle: item?.Tier3Name,
              Tier3Select: item,
              Tier4Details: item?.Tier4Details,
              TierData: true,
            });
          case 4:
            return setAssetList({
              ...assetList,
              ShowTitle: item?.Tier4Name,
              Tier4Select: item,
              Tier5Details: item?.Tier5Details,
              TierData: true,
            });
          default:
            return;
        }
      }
    }
  };

  useEffect(() => {
    if (
      !AttachmentsListPage &&
      machinesTypeList?.length !== 0 &&
      categoryofMachineList &&
      categoryofMachineList?.length !== 0 &&
      categoryofMachineList !== undefined
    ) {
      // ------------------ categoryofMachineList zero AssetTypeId ------------------
      // ------------------ categoryofMachineList One CategoryId --------------------
      // ------------------ categoryofMachineList two Tier1Id --------------------
      // ------------------ categoryofMachineList three Tier2Id --------------------
      // ------------------ categoryofMachineList four Tier3Id ------------------
      // ------------------ categoryofMachineList Five Tier4Id ------------------
      // ------------------ categoryofMachineList Six Category Name ------------------

      handleOnChangeTypePreviousPageDetails(
        `${categoryofMachineList[6] ?? null},${
          categoryofMachineList[0] ?? null
        },${categoryofMachineList[2] ?? null},${
          categoryofMachineList[3] ?? null
        },${categoryofMachineList[4] ?? null},${
          categoryofMachineList[1] ?? null
        }`
      );
    } else if (
      AttachmentsListPage &&
      machinesTypeList?.length !== 0 &&
      categoryofMachineList &&
      categoryofMachineList?.length !== 0 &&
      categoryofMachineList !== undefined
    ) {
      setMachineTypeSelectIdCategoryName(categoryofMachineList[1] ?? "");
      GetMachinesListSidebar(categoryofMachineList[1] ?? "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [machinesTypeList, categoryofMachineList]);

  useEffect(() => {
    if (allFilterID) {
      GetMachinesListSidebar();
    }
  }, [
    pageNumber,
    machinesTypeList,
    allFilterID,
    machineTypeSelectIdCategoryName,
    refresh,
  ]);

  useEffect(() => {
    if (state) {
      setIsLoading(true);
      setIsMachineData([]);
      handelSelectAssetTypeList(state, {
        Type: "CategoryDetails",
      });
    }
  }, []);

  const categoryId = id?.split("-")?.[0];

  useEffect(() => {
    if (!categoryId) {
      GetMachinesListSidebar();
    }
  }, [pageNumber, categoryId]);

  useEffect(() => {
    if (categoryId) {
      if (!assetCategorizationSummaryLoading && !isLoading && AssetTypeList) {
        const selecedData = getCategoryList(AssetTypeList)?.find(
          (item) => Number(item.CategoryId) === Number(categoryId)
        );
        if (selecedData) {
          handelSelectAssetTypeList(selecedData, {
            Type: "CategoryDetails",
          });
        } else {
          navigate("/");
        }
      }
    }
  }, [assetCategorizationSummaryLoading, categoryId]);

  const getCategoryList = (data) => {
    const CategoryData = data.find((item) => item.AssetTypeId === 2);
    // Order of categories you specified
    const desiredOrder = [38, 40, 39, 23, 44, 36, 35, 46, 41];

    const filteredCategories = [];
    CategoryData?.CategoryDetails.forEach((item) => {
      const indexInDesiredOrder = desiredOrder.indexOf(item?.CategoryId);
      if (indexInDesiredOrder !== -1) {
        // If the item is found in the desiredOrder, add it to filteredCategories
        filteredCategories[indexInDesiredOrder] = item;
      }
    });

    const resultCategories = filteredCategories.filter(
      (item) => item !== undefined
    );

    return resultCategories || [];
  };

  const componentCopyRef = useRef();

  const Copy = () => {
    const range = document.createRange();
    range.selectNode(componentCopyRef.current);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
  };

  useEffect(() => {
    if (copyMachine) {
      Copy();
    }
  }, [copyMachine]);
  return (
    <>
      <Box
        className={"p-l-14 p-b-50"}
        sx={{
          marginTop: {
            xs: "30px", // For extra small screens (mobile)
            sm: "40px", // For small screens (tablets)
            md: "50px", // For medium screens (laptops)
            lg: "60px", // For large screens (desktops)
          },
        }}
      >
        {copyMachine ? (
          <Box className="dashboard responsive_dashboard">
            <Box className="d-flex flex-col" minHeight={"50vh"}>
              <Box
                mr={"10px"}
                sx={{ cursor: "pointer" }}
                className="d-flex"
                justifyContent={"flex-end"}
              >
                <img
                  src={CopyIcon}
                  alt=""
                  width={"16px"}
                  onClick={() => setCopyMachine(!copyMachine)}
                />
              </Box>
              <table
                className="d-flex flex-col"
                ref={componentCopyRef}
                style={{ minHeight: "50vh" }}
              >
                <tbody>
                  {selecedEquipment.map((MachineDetails, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <MachineBoxUseCopy
                            MachineDetails={MachineDetails}
                            notShowCheckBox
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Box>
          </Box>
        ) : (
          <Grid container item spacing={4}>
            {!assetCategorizationSummaryLoading && !isLoading ? (
              <Grid item xs={12} md={12} lg={3}>
                <Box className={"inventory_category_box"}>
                  {getCategoryList(AssetTypeList).map((link) => {
                    return (
                      <Box
                        className={
                          selectCategoryType?.CategoryId === link?.CategoryId
                            ? "inventory_category_active"
                            : "inventory_category"
                        }
                        onClick={() => {
                          setSelectFilter({
                            ...selectFilter,
                            "45,000-80,000lbs": false,
                            "80,001-95,000lbs": false,
                            "95,001-125,000lbs": false,
                          });
                          localStorage.removeItem("selectFilter");
                          localStorage.removeItem("selectMachineID");
                          handelSelectFilter();
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                          navigate(
                            `/${
                              link?.CategoryId
                            }-${link?.CategoryName.toLowerCase().replaceAll(
                              " ",
                              "-"
                            )}`
                          );
                          handelSelectAssetTypeList(link, {
                            Type: "CategoryDetails",
                          });
                          localStorage.setItem(
                            "selectCategoryDetails",
                            link?.CategoryId
                          );
                        }}
                      >
                        {link.CategoryName}
                      </Box>
                    );
                  })}
                </Box>
              </Grid>
            ) : null}
            {isLoading || assetStartingLoader ? (
              <Grid item xs={12} md={12} lg={12}>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    marginTop: "30px",
                    height: "60vh",
                    alignItems: "center",
                  }}
                >
                  <div className="spinner-container">
                    <div className="loading-spinner"></div>
                  </div>
                </div>
              </Grid>
            ) : (
              <Grid item xs={12} md={12} lg={9}>
                <Box className="dashboard_right_box_without_animation">
                  {isMachineData.length === 0 && !isLoading ? (
                    <Box
                      className="MachineList_Category_box"
                      marginBottom={"30px"}
                    >
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        marginBottom={"30px"}
                        flexWrap={"wrap"}
                      >
                        <Box className="MachineList_V2_Category_title">
                          {selectCategoryType?.CategoryName}
                        </Box>

                        <Box display={"flex"} gap={"10px"}>
                          <Box
                            bgcolor={"#141215"}
                            display={"flex"}
                            alignItems={"center"}
                            sx={{ cursor: "pointer" }}
                            width={"40px"}
                            height={"40px"}
                            justifyContent={"center"}
                          >
                            <img src={GridIcon} alt="" />
                          </Box>
                          {selectCategoryType?.CategoryId === 38 && (
                            <Box
                              bgcolor={"#fff"}
                              display={"flex"}
                              alignItems={"center"}
                              sx={{ cursor: "pointer" }}
                              width={"40px"}
                              height={"40px"}
                              justifyContent={"center"}
                              onClick={handleClick}
                            >
                              <img src={FilterIcon} alt="" />
                            </Box>
                          )}
                          <Menu
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open}
                            onClose={handleClose}
                            slotProps={{
                              root: {
                                sx: {
                                  ".MuiPaper-elevation": { mt: "10px" },
                                  ".MuiList-padding": { py: 0 },
                                },
                              },
                              paper: {
                                elevation: 0,
                                sx: {
                                  overflow: "visible",
                                  filter:
                                    "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                  boxShadow: "0px 10px 50px 0px #00000040",
                                  mt: 1.5,
                                  "& .MuiAvatar-root": {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                  },
                                  "&::before": {
                                    content: '""',
                                    display: "block",
                                    position: "absolute",
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: "background.paper",
                                    transform: "translateY(-50%) rotate(45deg)",
                                    zIndex: 0,
                                  },
                                },
                              },
                            }}
                            transformOrigin={{
                              horizontal: "right",
                              vertical: "top",
                            }}
                            anchorOrigin={{
                              horizontal: "right",
                              vertical: "bottom",
                            }}
                          >
                            <Box padding={"12px 20px"}>
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                              >
                                <Box
                                  onClick={(e) => {
                                    handleClose();
                                    setSelectFilter({
                                      ...selectFilter,
                                      "45,000-80,000lbs": false,
                                      "80,001-95,000lbs": false,
                                      "95,001-125,000lbs": false,
                                    });
                                    localStorage.setItem(
                                      "selectFilter",
                                      JSON.stringify({
                                        ...selectFilter,
                                        "45,000-80,000lbs": false,
                                        "80,001-95,000lbs": false,
                                        "95,001-125,000lbs": false,
                                      })
                                    );
                                    handelSelectFilter();
                                  }}
                                  className="reset_btn"
                                  style={{ cursor: "pointer" }}
                                >
                                  Reset
                                </Box>
                              </Box>

                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                              >
                                <Box className="drop_down_label">
                                  45,000-80,000lbs
                                </Box>
                                <Box>
                                  <input
                                    type="checkbox"
                                    className="drop_down_checkbox"
                                    checked={selectFilter?.["45,000-80,000lbs"]}
                                    onClick={(e) => {
                                      handleClose();
                                      setSelectFilter({
                                        ...selectFilter,
                                        "45,000-80,000lbs": e.target.checked,
                                      });
                                      localStorage.setItem(
                                        "selectFilter",
                                        JSON.stringify({
                                          ...selectFilter,
                                          "45,000-80,000lbs": e.target.checked,
                                        })
                                      );
                                      handelSelectFilter();
                                    }}
                                  />
                                </Box>
                              </Box>

                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                              >
                                <Box className="drop_down_label">
                                  80,001-95,000lbs
                                </Box>
                                <Box>
                                  <input
                                    type="checkbox"
                                    className="drop_down_checkbox"
                                    checked={selectFilter?.["80,001-95,000lbs"]}
                                    onClick={(e) => {
                                      handleClose();
                                      setSelectFilter({
                                        ...selectFilter,
                                        "80,001-95,000lbs": e.target.checked,
                                      });
                                      localStorage.setItem(
                                        "selectFilter",
                                        JSON.stringify({
                                          ...selectFilter,
                                          "80,001-95,000lbs": e.target.checked,
                                        })
                                      );
                                      handelSelectFilter();
                                    }}
                                  />
                                </Box>
                              </Box>

                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                              >
                                <Box className="drop_down_label">
                                  95,001-125,000lbs
                                </Box>
                                <Box>
                                  <input
                                    type="checkbox"
                                    className="drop_down_checkbox"
                                    checked={
                                      selectFilter?.["95,001-125,000lbs"]
                                    }
                                    onClick={(e) => {
                                      handleClose();
                                      setSelectFilter({
                                        ...selectFilter,
                                        "95,001-125,000lbs": e.target.checked,
                                      });
                                      localStorage.setItem(
                                        "selectFilter",
                                        JSON.stringify({
                                          ...selectFilter,
                                          "95,001-125,000lbs": e.target.checked,
                                        })
                                      );

                                      handelSelectFilter();
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Box>
                          </Menu>
                        </Box>
                      </Box>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "center",
                          marginTop: "30px",
                          height: "40vh",
                          alignItems: "center",
                        }}
                      >
                        <div className="spinner-container">
                          <Box className="No_Machine">No Machine Available</Box>
                        </div>
                      </div>
                    </Box>
                  ) : (
                    <>
                      <MachineListComponent
                        copyMachine={copyMachine}
                        setCopyMachine={setCopyMachine}
                        selecedEquipment={selecedEquipment}
                        setSelecedEquipment={setSelecedEquipment}
                        selectCategoryType={selectCategoryType}
                        selectedCheckList={selectedCheckList}
                        isMachineData={isMachineData}
                        setSelectedCheckList={setSelectedCheckList}
                        selectFilter={selectFilter}
                        setSelectFilter={setSelectFilter}
                        handelSelectFilter={handelSelectFilter}
                        machineRefs={machineRefs}
                      />
                    </>
                  )}
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Pagination
                      count={Math.ceil(totalRecords / limit)}
                      page={Number(pageNumber)}
                      onChange={(event, value) => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                        localStorage.setItem("currentPage", Number(value));
                        setPageNumber(value);
                      }}
                      variant="outlined"
                      shape="rounded"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          color: "#facd40",
                          borderColor: "#facd40",
                        },
                        "& .Mui-selected": {
                          backgroundColor: "#facd40 !important",
                          color: "#000 !important",
                        },
                        "& .MuiPaginationItem-ellipsis": {
                          color: "#facd40",
                        },
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </>
  );
};
export default EquipmentComponent;
